<template>
    <div
        
        class="is-paddingless"
        @click.stop
    >
        <object-card-basic
            :content="object"
            :is-creation="creationEnabled"
            :is-edition="editionEnabled"
            :index="index"
            :selected-object="selectedObject"
            :canCreateOrEditObjects="canCreateOrEditObjects"
            @click="openObject"
            @view="viewObject"
            @remove="removeObject"
            @hover="hoverIn"
            @leave="hoverOut"
        />
            

        <div
            v-for="(related, trigger) in object.triggers"
            :key="trigger"
            class="has-text-centered" 
        >
    
            <div
                v-if="trigger != 'END' || creationEnabled"
                class="columns mb-0 is-centered"
            >
                <svg
                    preserveAspectRatio="none"
                    fill="none"
                    height="10px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M150 0L150 80L150 80"
                        stroke="#C5CCD0"
                        stroke-width="2px"
                    />
                </svg>
            </div>
            <object-card-trigger-buttons
                :creationEnabled="creationEnabled"
                :trigger="{ type: trigger }"
                :available-objects="availableObjects"
                :showObjectButtons="showObjectButtons"
                :canCreateOrEditObjects="canCreateOrEditObjects"
                :editionEnabled="editionEnabled"
                :hideButtons="hideButtons"
                :canCreateObject="canCreateObject"
                class="has-text-centered"
                @add="$emit('add', { ...$event, ...{ trigger } })"
                @closeOthers="$emit('closeOthers')"
                
            />
            <div
                v-if="trigger != 'END' && !showObjectButtons"
                class="columns mb-0 is-centered"
            >
                <svg
                    preserveAspectRatio="none"
                    fill="none"
                    height="10px"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M150 0L150 80L150 80"
                        stroke="#C5CCD0"
                        stroke-width="2px"
                    />
                    <path d="M145 75H155L150 80L145 75Z" fill="#C5CCD0" />
                </svg>
            </div>
        
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import ObjectCardSimplified from '@/components/ObjectCardSimplified';
import ObjectCardBasic from '@/components/ObjectCardBasic';
import ObjectCardTriggerButtons from '@/components/ObjectCardTriggerButtons';
import { TREASUREHUNT_OBJECT_TYPES } from '@/lib/constants';

export default {
    name: 'ProjectTreasurehuntCard',
    components: {
        ObjectCardBasic,
        ObjectCardSimplified,
        ObjectCardTriggerButtons,
    },
    model: {
        prop: 'object',
    },
    props: {
        object: {
            type: Object,
            default() {
                return {
                    _id: 'draft',
                };
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        showObjectButtons: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            default: 1
        },
        selectedObject: {
            type: String,
            default: undefined,
        },
        canCreateOrEditObjects: {
            type: Boolean,
            default: false,
        },
        editionEnabled: {
            type: Boolean,
            default: false,
        },
        creationEnabled: {
            type: Boolean,
            default: false,
        },
        hideButtons: {
            type: Boolean,
            default: false,
        },
        canCreateObject: { type: Boolean, default: false },
    },
    data() {
        return {
            objectSource: { ...this.object },
        };
    },
    computed: {
        availableObjects() {
            return TREASUREHUNT_OBJECT_TYPES;
        },
    },
    watch: {
        object: {
            deep: true,
            handler(newObject) {
                this.objectSource = newObject;
                // console.log('newObject', this.objectSource);
            },
        },
    },
    methods: {
        openObject(e){
            //console.log("editing object",this.object)
            this.$emit("edit-object",this.object);
            
        },
        hoverIn(e){
            if(e.type=="clue"){
                this.$emit('hover',e);
            }
            
        },
        hoverOut(e){
            if(e.type=="clue"){
                this.$emit('leave',e);
            }
        },
        viewObject(){
            this.$emit("view",this.object);
        },
        removeObject(){
            this.$emit("remove",this.object);
        }
    },
};
</script>
